import React, { Component } from 'react';
import './App.css';

import Oreo from './Oero';

class App extends Component {
  state = {
    oreo: "ORRRROROORRO",
    oreoText: 'OREREREREOREOOREREO'
  }
  hangleChange = (event) => {
    let name = event.target.name;
    this.setState({
      [name]: event.target.value,
    })
  }
  hangleClick = (dict) => {
    this.setState((state) => {
      let str = state.oreoText;
      str = str.split('').reduce((acc, ch) => {
        if (ch === '奥') ch = 'O';
        if (ch === '利') ch = 'R';
        return ch === 'O' || ch === 'R' ? acc + ch : acc;
      }, '');
      return {
        oreo: str,
        oreoText: this.translateFactory(dict)(str),
      };
    });
  }
  translateFactory(dict) {
    return str => str.split('').map(ch => dict[ch]).join('');
  }
  dictCN = { 'O': '奥', 'R': '利' };
  dictEN = { 'O': 'O', 'R': 'RE' };
  handleRandom = (dict) => {
    function getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    }
    let len = getRandomInt(10) + 1;
    let oreoText = '';
    for (let i = 0; i < len; i++) {
      oreoText += (getRandomInt(2) === 0 ? 'O' : 'RE');
    }
    this.setState({
      oreoText: oreoText
    }, () => this.hangleClick(dict));
  }
  render() {
    return <div style={{ textAlign: "center" }}>
      <div>
        <input type="button" name="RandomCH" onClick={() => this.handleRandom(this.dictCN)} value="随机" />
        <input type="button" name="Random" onClick={() => this.handleRandom(this.dictEN)} value="Random" />
        <input type="text" name="oreoText" onChange={this.hangleChange} value={this.state.oreoText} />
        <input type="button" name="GenerateCH" onClick={() => this.hangleClick(this.dictCN)} value="生成" />
        <input type="button" name="Generate" onClick={() => this.hangleClick(this.dictEN)} value="Generate" />
      </div>
      <Oreo oreo={this.state.oreo} ref1={this.oreoRef}/>
    </div>;
  }
}

export default App;
